import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import AnalyticsPage from "../../components/analytics/AnalyticsPage";
import { useParams } from "react-router-dom";
import { typeConversionHelper } from "../../helpers";
import analyticsDynamicWidgetApi from "../../api/analytics/analyticsDynamicWidgetApi";
import { DynamicAnalyticsPageMetaData } from "../../types/analytics";
import { AnalyticsPageJourneyFilterRestriction } from "../../types/analytics/AnalyticsFilterInputs";

function DynamicAnalyticsPage() {
  const auth = useAuth();
  const { pageId } = useParams();
  const numericPageId = typeConversionHelper.stringToNumber(pageId);

  const [pageTitle, setPageTitle] = useState<string>("");
  const [journeyRestriction, setJourneyRestriction] =
    useState<AnalyticsPageJourneyFilterRestriction>("SHOW-ALL");
  const [defaultJourneyFilterPattern, setDefaultJourneyFilterPattern] =
    useState<string | null>(null);

  const [dynamicPageId, setDynamicPageId] = useState<number | undefined>(
    undefined
  );
  const [appliedPointInTimeDate, setAppliedPointInTimeDate] = useState<
    string | null
  >(null);

  const pageIdIsValid =
    dynamicPageId && !isNaN(dynamicPageId) && dynamicPageId > 0;

  const dynamicWidgetApi = new analyticsDynamicWidgetApi(
    auth.user?.access_token,
    numericPageId ? numericPageId : 0
  );

  // On page load, page change, or applied Data snapshot date change
  useEffect(() => {
    loadPageMetaDataFromApi(appliedPointInTimeDate);
  }, [pageId, appliedPointInTimeDate]);

  function loadPageMetaDataFromApi(pointInTimeDate: string | null) {
    if (numericPageId === undefined || isNaN(numericPageId)) {
      return;
    }

    const onSuccess = (data: DynamicAnalyticsPageMetaData) => {
      setPageTitle("Analytics: " + data.pageTitle);
      setJourneyRestriction(data.journeyFilterRestriction);
      setDefaultJourneyFilterPattern(data.defaultJourneyFilterPattern);
      setDynamicPageId(data.pageId);
    };

    const onError = (error: any) => {
      console.error("Unable to load analytics page meta data", error);
    };

    dynamicWidgetApi.getPageMeta(onSuccess, onError, pointInTimeDate);
  }

  if (dynamicPageId == undefined || !pageIdIsValid) {
    // Don't render anything if the page id param is invalid
    return null;
  }

  return (
    <AnalyticsPage
      pageIdentifier={`Dynamic_${dynamicPageId.toString()}`}
      title={pageTitle}
      translateTitle={false}
      journeyFilterDefaultValueMode="MULTI"
      journeyFilterRestriction={journeyRestriction}
      contentType="WIDGETS"
      analyticsPageApi={dynamicWidgetApi}
      dynamicPageId={dynamicPageId}
      defaultJourneyFilterPattern={defaultJourneyFilterPattern}
      onAppliedPointInTimeDateChange={setAppliedPointInTimeDate}
    />
  );
}

export default DynamicAnalyticsPage;
